const NavBar = () => {
    return ( 
        <nav>
            welcome to daily dose of cats 
        </nav>
     );
}
 
export default NavBar;